/**
 * The brutalist square −/value/+ stepper (`.be-stepper`, `brutalist-editor.css`): the PILOT sheet's
 * EDIT mode steps license level, HASE and trigger/talent/license ranks with it
 * (`PilotSheetEdit.tsx`). `label` builds its `increment …`/`decrement …` names, which the e2e flows click.
 */
export function Stepper({
  display,
  label,
  accent = false,
  canDec,
  canInc,
  onDec,
  onInc,
}: {
  display: string;
  label: string;
  accent?: boolean;
  canDec: boolean;
  canInc: boolean;
  onDec: () => void;
  onInc: () => void;
}) {
  return (
    <div className={`be-stepper${accent ? " accent" : ""}`}>
      <button type="button" className="be-step" disabled={!canDec} aria-label={`decrement ${label}`} onClick={onDec}>
        −
      </button>
      <div className="be-stepval">{display}</div>
      <button type="button" className="be-step" disabled={!canInc} aria-label={`increment ${label}`} onClick={onInc}>
        +
      </button>
    </div>
  );
}
